// Preload and cache animation data
let cachedAnimationData = null;
let loadingPromise = null;

export const loadDamageAnimation = async () => {
  if (cachedAnimationData) {
    return cachedAnimationData;
  }
  
  if (loadingPromise) {
    return loadingPromise;
  }
  
  loadingPromise = fetch('/animations/red explosion.json')
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      cachedAnimationData = data;
      return data;
    })
    .catch(error => {
      loadingPromise = null;
      return null;
    });
  
  return loadingPromise;
};

